import { User } from "@/modules/working_hours/domain/User";
import { APIUserRepo } from "@/modules/working_hours/infra/APIUserRepo";
import { UserRepo } from "@/modules/working_hours/domain/UserRepo";



interface AdminScreenData {
  users: User[]; 
  currentMonth: number;
  currentYear: number;
  isLoading?: boolean; 
}

export class LoadAdminMonthView {
  constructor(
    private userRepository: UserRepo,
    private screenData: AdminScreenData
  ) {   
  }

  async execute(): Promise<void> {
    this.screenData.isLoading = true;
    const users = await this.userRepository.find_all();
    this.screenData.users = users;
    this.screenData.isLoading = false;
  }
}